import script from "./GroupTalkReports.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupTalkReports.vue?vue&type=script&setup=true&lang=js"

import "./GroupTalkReports.vue?vue&type=style&index=0&id=05b60fae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b60fae"]])

export default __exports__